module.exports = __webpack_public_path__ + "img/BLCA_Mono.Macro.499dda0d.png";